import { render, staticRenderFns } from "./RecentlyCreatedIcon.vue?vue&type=template&id=251f6582&scoped=true"
import script from "./RecentlyCreatedIcon.vue?vue&type=script&lang=ts"
export * from "./RecentlyCreatedIcon.vue?vue&type=script&lang=ts"
import style0 from "./RecentlyCreatedIcon.vue?vue&type=style&index=0&id=251f6582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251f6582",
  null
  
)

export default component.exports